module.exports = __webpack_public_path__ + "media/winner_full_house_5.c3b491b1.mp3";